let boundHostOrigin: string | null = null;

export function getBoundHostOrigin(): string | null {
  return boundHostOrigin;
}

export function setBoundHostOrigin(origin: string): void {
  boundHostOrigin = origin;
}
